export const adminCommissions = {
  "admin.commissions.pageTitle": "Komisyon Yönetimi",
  "admin.commissions.pageDescription": "Sistemdeki tüm komisyon verilerini yönetin ve görüntüleyin",

  "admin.commissions.tracker.title": "Komisyon Takibi",
  "admin.commissions.tracker.subtitle": "Tüm kullanıcılardaki detaylı komisyon kazançlarını takip edin",
  "admin.commissions.tracker.errorTitle": "Takip Verileri Yüklenirken Hata",
  "admin.commissions.tracker.errorMessage": "Komisyon takip verileri yüklenemedi",
  "admin.commissions.tracker.retryButton": "Tekrar Dene",
  
  "admin.commissions.tracker.filters.title": "Filtreler",
  "admin.commissions.tracker.filters.ancestorUsername": "Ata Kullanıcı Adı",
  "admin.commissions.tracker.filters.ancestorUsernamePlaceholder": "Ata kullanıcı adını girin",
  "admin.commissions.tracker.filters.referralUsername": "Referans Kullanıcı Adı",
  "admin.commissions.tracker.filters.referralUsernamePlaceholder": "Referans kullanıcı adını girin",
  "admin.commissions.tracker.filters.accountNumber": "Hesap Numarası",
  "admin.commissions.tracker.filters.accountNumberPlaceholder": "Hesap numarasını girin",
  "admin.commissions.tracker.filters.level": "Kademe",
  "admin.commissions.tracker.filters.levelPlaceholder": "Kademe seçin",
  "admin.commissions.tracker.filters.allLevels": "Tüm Kademeler",
  "admin.commissions.tracker.filters.leftoverCommission": "Artık Komisyon",
  "admin.commissions.tracker.filters.leftoverCommissionPlaceholder": "Seçenek seçin",
  "admin.commissions.tracker.filters.allLeftover": "Tümü",
  "admin.commissions.tracker.filters.leftoverYes": "Evet",
  "admin.commissions.tracker.filters.leftoverNo": "Hayır",
  "admin.commissions.tracker.filters.dateFrom": "Dönem Başlangıç",
  "admin.commissions.tracker.filters.dateTo": "Dönem Bitiş",
  "admin.commissions.tracker.filters.commissionMin": "Min Komisyon",
  "admin.commissions.tracker.filters.commissionMinPlaceholder": "Minimum tutar",
  "admin.commissions.tracker.filters.commissionMax": "Maks Komisyon",
  "admin.commissions.tracker.filters.commissionMaxPlaceholder": "Maksimum tutar",
  "admin.commissions.tracker.filters.profitMin": "Min Kâr",
  "admin.commissions.tracker.filters.profitMinPlaceholder": "Minimum kâr",
  "admin.commissions.tracker.filters.profitMax": "Maks Kâr",
  "admin.commissions.tracker.filters.profitMaxPlaceholder": "Maksimum kâr",
  "admin.commissions.tracker.filters.applyFilters": "Filtreleri Uygula",
  "admin.commissions.tracker.filters.clearFilters": "Filtreleri Temizle",
  
  "admin.commissions.tracker.table.title": "Komisyon Takibi",
  "admin.commissions.tracker.table.ancestorUsername": "Ata",
  "admin.commissions.tracker.table.ancestorName": "Ata Adı",
  "admin.commissions.tracker.table.referralUsername": "Referans",
  "admin.commissions.tracker.table.referralName": "Referans Adı",
  "admin.commissions.tracker.table.accountNumber": "Hesap",
  "admin.commissions.tracker.table.period": "Dönem",
  "admin.commissions.tracker.table.leftover": "Artık",
  "admin.commissions.tracker.table.leftoverYes": "Evet",
  "admin.commissions.tracker.table.leftoverNo": "Hayır",
  "admin.commissions.tracker.table.level": "Kademe",
  "admin.commissions.tracker.table.levelCompany": "Şirket",
  "admin.commissions.tracker.table.levelLeftover": "Kalan",
  "admin.commissions.tracker.table.commissionPercent": "Komisyon %",
  "admin.commissions.tracker.table.commission": "Komisyon",
  "admin.commissions.tracker.table.profitAccount": "Kâr Hesabı",
  "admin.commissions.tracker.table.noData": "Komisyon takip verisi bulunamadı",
  "admin.commissions.tracker.table.error": "Komisyon takip verileri yüklenirken hata",
  "admin.commissions.tracker.table.showing": "Gösterilen",
  "admin.commissions.tracker.table.of": "/",
  "admin.commissions.tracker.table.records": "kayıt",

  "admin.commissions.profits.title": "Komisyon Kârları",
  "admin.commissions.profits.subtitle": "Komisyon kâr geçmişini görüntüleyin ve analiz edin",
  "admin.commissions.profits.errorTitle": "Veri Yüklenirken Hata",
  "admin.commissions.profits.errorMessage": "Komisyon kâr verileri yüklenemedi",
  "admin.commissions.profits.retryButton": "Tekrar Dene",

  "admin.commissions.profits.filters.title": "Filtreler",
  "admin.commissions.profits.filters.user": "Kullanıcı",
  "admin.commissions.profits.filters.userPlaceholder": "Kullanıcı adını girin",
  "admin.commissions.profits.filters.period": "Dönem",
  "admin.commissions.profits.filters.dateFrom": "Başlangıç Tarihi",
  "admin.commissions.profits.filters.dateTo": "Bitiş Tarihi",
  "admin.commissions.profits.filters.commissionAmount": "Komisyon Tutarı",
  "admin.commissions.profits.filters.commissionMin": "Min Komisyon",
  "admin.commissions.profits.filters.commissionMinPlaceholder": "Minimum tutar",
  "admin.commissions.profits.filters.commissionMax": "Maks Komisyon",
  "admin.commissions.profits.filters.commissionMaxPlaceholder": "Maksimum tutar",
  "admin.commissions.profits.filters.leftoverCommission": "Artık Komisyon",
  "admin.commissions.profits.filters.leftoverCommissionPlaceholder": "Artık komisyon seçin",
  "admin.commissions.profits.filters.allLeftover": "Tümü",
  "admin.commissions.profits.filters.leftoverYes": "Evet",
  "admin.commissions.profits.filters.leftoverNo": "Hayır",
  "admin.commissions.profits.filters.applyFilters": "Filtreleri Uygula",
  "admin.commissions.profits.filters.clearFilters": "Filtreleri Temizle",

  "admin.commissions.profits.table.title": "Komisyon Kârları",
  "admin.commissions.profits.table.username": "Kullanıcı Adı",
  "admin.commissions.profits.table.name": "Ad",
  "admin.commissions.profits.table.period": "Dönem",
  "admin.commissions.profits.table.commissionAmount": "Komisyon Tutarı",
  "admin.commissions.profits.table.leftover": "Artık",
  "admin.commissions.profits.table.leftoverYes": "Evet",
  "admin.commissions.profits.table.leftoverNo": "Hayır",
  "admin.commissions.profits.table.noData": "Komisyon verisi bulunamadı",
  "admin.commissions.profits.table.error": "Komisyon verileri yüklenirken hata",
  "admin.commissions.profits.table.showing": "Gösterilen",
  "admin.commissions.profits.table.of": "/",
  "admin.commissions.profits.table.records": "kayıt",

  "admin.commissions.totals.title": "Komisyon Toplamları",
  "admin.commissions.totals.subtitle": "Kullanıcıya göre toplam komisyon kazançlarını görüntüleyin ve analiz edin",
  "admin.commissions.totals.errorTitle": "Veri Yüklenirken Hata",
  "admin.commissions.totals.errorMessage": "Komisyon toplamları verileri yüklenemedi",
  "admin.commissions.totals.retryButton": "Tekrar Dene",

  "admin.commissions.totals.filters.title": "Filtreler",
  "admin.commissions.totals.filters.user": "Kullanıcı",
  "admin.commissions.totals.filters.userPlaceholder": "Kullanıcı adını girin",
  "admin.commissions.totals.filters.commissionAmount": "Komisyon Tutarı",
  "admin.commissions.totals.filters.commissionMin": "Min Komisyon",
  "admin.commissions.totals.filters.commissionMinPlaceholder": "Minimum tutar",
  "admin.commissions.totals.filters.commissionMax": "Maks Komisyon",
  "admin.commissions.totals.filters.commissionMaxPlaceholder": "Maksimum tutar",
  "admin.commissions.totals.filters.applyFilters": "Filtreleri Uygula",
  "admin.commissions.totals.filters.clearFilters": "Filtreleri Temizle",

  "admin.commissions.totals.table.title": "Komisyon Toplamları",
  "admin.commissions.totals.table.username": "Kullanıcı Adı",
  "admin.commissions.totals.table.name": "Ad",
  "admin.commissions.totals.table.totalCommission": "Toplam Komisyonlar",
  "admin.commissions.totals.table.lastUpdate": "Son Güncelleme",
  "admin.commissions.totals.table.noData": "Komisyon toplamı verisi bulunamadı",
  "admin.commissions.totals.table.error": "Komisyon toplamları verileri yüklenirken hata",
  "admin.commissions.totals.table.showing": "Gösterilen",
  "admin.commissions.totals.table.of": "/",
  "admin.commissions.totals.table.records": "kayıt",

  "admin.commissions.balances.title": "Komisyon Bakiyeleri",
  "admin.commissions.balances.subtitle": "Tüm kullanıcılar için komisyon bakiye verilerini görüntüleyin ve yönetin",
  "admin.commissions.balances.errorTitle": "Veri Yüklenirken Hata",
  "admin.commissions.balances.errorMessage": "Komisyon bakiye verileri yüklenemedi",
  "admin.commissions.balances.retryButton": "Tekrar Dene",

  "admin.commissions.balances.filters.title": "Filtreler",
  "admin.commissions.balances.filters.user": "Kullanıcı",
  "admin.commissions.balances.filters.userPlaceholder": "Kullanıcı adını girin",
  "admin.commissions.balances.filters.balanceAmount": "Bakiye Tutarı",
  "admin.commissions.balances.filters.balanceMinPlaceholder": "Min tutar",
  "admin.commissions.balances.filters.balanceMaxPlaceholder": "Maks tutar",
  "admin.commissions.balances.filters.paidAmount": "Ödenen Tutar",
  "admin.commissions.balances.filters.paidMinPlaceholder": "Min ödenen",
  "admin.commissions.balances.filters.paidMaxPlaceholder": "Maks ödenen",
  "admin.commissions.balances.filters.applyFilters": "Filtreleri Uygula",
  "admin.commissions.balances.filters.clearFilters": "Filtreleri Temizle",

  "admin.commissions.balances.table.title": "Komisyon Bakiyeleri",
  "admin.commissions.balances.table.username": "Kullanıcı Adı",
  "admin.commissions.balances.table.name": "Ad",
  "admin.commissions.balances.table.currentBalance": "Mevcut Bakiye",
  "admin.commissions.balances.table.totalPaid": "Toplam Ödenen",
  "admin.commissions.balances.table.lastUpdate": "Son Güncelleme",
  "admin.commissions.balances.table.noData": "Komisyon bakiye verisi bulunamadı",
  "admin.commissions.balances.table.error": "Komisyon bakiye verileri yüklenirken hata",
  "admin.commissions.balances.table.loading": "Yükleniyor...",
  "admin.commissions.balances.table.showing": "Gösterilen",
  "admin.commissions.balances.table.of": "/",
  "admin.commissions.balances.table.records": "kayıt",

  "admin.commissions.payments.title": "Komisyon Ödemeleri",
  "admin.commissions.payments.subtitle": "Komisyon ödeme geçmişini takip edin ve yönetin",
  "admin.commissions.payments.errorTitle": "Ödemeler Yüklenirken Hata",
  "admin.commissions.payments.errorMessage": "Komisyon ödeme verileri yüklenemedi",
  "admin.commissions.payments.retryButton": "Tekrar Dene",

  "admin.commissions.payments.filters.title": "Filtreler",
  "admin.commissions.payments.filters.user": "Kullanıcı Adı",
  "admin.commissions.payments.filters.userPlaceholder": "Kullanıcı adını girin",
  "admin.commissions.payments.filters.dateFrom": "Ödeme Tarihi Başlangıç",
  "admin.commissions.payments.filters.dateTo": "Ödeme Tarihi Bitiş",
  "admin.commissions.payments.filters.paymentAmountMin": "Min Ödeme Tutarı",
  "admin.commissions.payments.filters.paymentAmountMinPlaceholder": "Min tutar",
  "admin.commissions.payments.filters.paymentAmountMax": "Maks Ödeme Tutarı",
  "admin.commissions.payments.filters.paymentAmountMaxPlaceholder": "Maks tutar",
  "admin.commissions.payments.filters.paymentStatus": "Ödeme Durumu",
  "admin.commissions.payments.filters.paymentStatusPlaceholder": "Durum seçin",
  "admin.commissions.payments.filters.allStatuses": "Tüm Durumlar",
  "admin.commissions.payments.filters.applyFilters": "Filtreleri Uygula",
  "admin.commissions.payments.filters.clearFilters": "Filtreleri Temizle",

  "admin.commissions.payments.table.title": "Komisyon Ödemeleri",
  "admin.commissions.payments.table.username": "Kullanıcı Adı",
  "admin.commissions.payments.table.name": "Ad",
  "admin.commissions.payments.table.paymentAmount": "Ödeme Tutarı",
  "admin.commissions.payments.table.feeAmount": "Ücret Tutarı",
  "admin.commissions.payments.table.netAmount": "Net Tutar",
  "admin.commissions.payments.table.paymentDate": "Ödeme Tarihi",
  "admin.commissions.payments.table.paymentStatus": "Durum",
  "admin.commissions.payments.table.paymentAccount": "Ödeme Hesabı",
  "admin.commissions.payments.table.noData": "Ödeme kaydı bulunamadı",
  "admin.commissions.payments.table.error": "Ödeme verileri yüklenirken hata",
  "admin.commissions.payments.table.showing": "Gösterilen",
  "admin.commissions.payments.table.of": "/",
  "admin.commissions.payments.table.records": "kayıt",
  
  "admin.commissions.payments.status.pending": "Beklemede",
  "admin.commissions.payments.status.paid": "Ödendi",
  "admin.commissions.payments.status.completed": "Tamamlandı",
  "admin.commissions.payments.status.cancelled": "İptal Edildi",
  "admin.commissions.payments.status.failed": "Başarısız",
  "admin.commissions.payments.status.rejected": "Reddedildi",

  "admin.commissions.models.title": "Komisyon Modelleri",
  "admin.commissions.models.subtitle": "Tüm komisyon modellerini ve kademe yapılarını görüntüleyin",
  "admin.commissions.models.errorTitle": "Komisyon Modelleri Yüklenirken Hata",
  "admin.commissions.models.errorMessage": "Komisyon modelleri verileri yüklenemedi",
  "admin.commissions.models.retryButton": "Tekrar Dene",
  "admin.commissions.models.loading": "Komisyon modelleri yükleniyor...",

  "admin.commissions.models.card.name": "Model Adı",
  "admin.commissions.models.card.description": "Açıklama",
  "admin.commissions.models.card.maxLevels": "Maks Kademe",
  "admin.commissions.models.card.createdAt": "Oluşturulma",
  "admin.commissions.models.card.updatedAt": "Son Güncelleme",
  "admin.commissions.models.card.levelTable.title": "Komisyon Yapısı",
  "admin.commissions.models.card.levelTable.level": "Kademe",
  "admin.commissions.models.card.levelTable.percentage": "Komisyon %",
  "admin.commissions.models.card.noLevels": "Komisyon kademesi tanımlanmamış",

  "admin.commissions.manager.title": "Komisyon Yöneticisi",
  "admin.commissions.manager.subtitle": "Aylık komisyon işleme hesaplaması ve yönetimi",
  "admin.commissions.manager.form.title": "Aylık Komisyon Hesaplaması",
  "admin.commissions.manager.form.description": "Komisyonları işlemek için hedef ayı seçin",
  "admin.commissions.manager.form.periodLabel": "Hedef Dönem",
  "admin.commissions.manager.form.periodHint": "Format: yyyy-aa-01 (ör.",
  "admin.commissions.manager.form.periodFormatError": "Dönem yyyy-aa-01 formatında olmalıdır",
  "admin.commissions.manager.form.calculateButton": "Komisyonları Hesapla",
  "admin.commissions.manager.form.calculating": "Hesaplanıyor...",
  "admin.commissions.manager.results.title": "Komisyon Hesaplama Sonuçları",
  "admin.commissions.manager.results.description": "İşleme ayı için sonuçlar",
  "admin.commissions.manager.results.processingMonth": "İşleme Ayı",
  "admin.commissions.manager.results.totalWorkers": "Toplam İşçi",
  "admin.commissions.manager.results.processingDuration": "İşleme Süresi",
  "admin.commissions.manager.results.totalProcessed": "İşlenen Kayıtlar",
  "admin.commissions.manager.results.totalFailed": "Başarısız Kayıtlar",
  "admin.commissions.manager.results.successRate": "Başarı Oranı",
  "admin.commissions.manager.results.totalCommissionAmount": "Toplam Komisyon Tutarı",
  "admin.commissions.manager.results.totalLeftoverAmount": "Toplam Artık Tutar",
  "admin.commissions.manager.logs.title": "Komisyon İşleme Günlükleri",
  "admin.commissions.manager.logs.description": "Komisyon hesaplamaları için detaylı günlükleri görüntüleyin",
  "admin.commissions.manager.logs.filterLabel": "Aya Göre Filtrele",
  "admin.commissions.manager.logs.searchButton": "Ara",
  "admin.commissions.manager.logs.clearButton": "Temizle",
  "admin.commissions.manager.logs.showing": "Gösterilen",
  "admin.commissions.manager.logs.records": "kayıt",
  "admin.commissions.manager.logs.noLogs": "Komisyon günlüğü bulunamadı",
  "admin.commissions.manager.logs.table.month": "Ay",
  "admin.commissions.manager.logs.table.workerId": "İşçi Kimliği",
  "admin.commissions.manager.logs.table.status": "Durum",
  "admin.commissions.manager.logs.table.processed": "İşlenen",
  "admin.commissions.manager.logs.table.failed": "Başarısız",
  "admin.commissions.manager.logs.table.commissionAmount": "Komisyon Tutarı",
  "admin.commissions.manager.logs.table.leftoverAmount": "Artık Tutar",
  "admin.commissions.manager.logs.table.startedAt": "Başlangıç",
  "admin.commissions.manager.logs.table.completedAt": "Tamamlanma",
  "admin.commissions.manager.logs.table.duration": "Süre",
  "admin.commissions.manager.error.title": "Komisyon İşleme Hatası",
  "admin.commissions.manager.error.message": "Komisyonlar işlenirken bir hata oluştu"
};
